require('./dist/polyfill')